function generateReferralId() {
  let generatedId = ''
  const charSet = '0123456789abcdefghijklmnopqrstuvwxyz'
  const charSetLength = charSet.length
  for (let i=0; i < 6; i++) {
    generatedId += charSet[Math.floor(Math.random() * charSetLength)]
  }
  return generatedId
}

export {
  generateReferralId,
}